import { render } from "./_Home.vue?vue&type=template&id=511707a4&ts=true"
import script from "./_Home.vue?vue&type=script&lang=ts"
export * from "./_Home.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./_Home.vue?vue&type=style&index=0&id=511707a4&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__